module.exports = __webpack_public_path__ + "js/stellarium-web-engine.0cb80a89.wasm";